export default "__VITE_ASSET__DLg8G9v6__"